import { ROUTES } from "definitions/constant/routes";
import * as React from "react";
// component
import Iconify from "../components/Iconify";

// ----------------------------------------------------------------------

export interface INavConfig {
  title: string;
  path: string;
  icon: React.ReactNode;
}

export const getIcon = (name: string) => (
  <Iconify icon={name} width={22} height={22} />
);

export const adminUserNavConfig: INavConfig[] = [
  {
    title: "dashboard",
    path: ROUTES.root,
    icon: getIcon("eva:pie-chart-2-fill"),
  },
  {
    title: "Register Consumer",
    path: "/register",
    icon: getIcon("mdi:register"),
  },
  {
    title: "Find Consumer",
    path: "/find",
    icon: getIcon("eva:search-fill"),
  },

  {
    title: "Date Wise Reports",
    path: "/reports",
    icon: getIcon("ic:baseline-sim-card-download"),
  },
  {
    title: "File upload",
    path: "/uploads",
    icon: getIcon("material-symbols:cloud-upload"),
  },
  {
    title: "Sales & Connection",
    path: "/connections",
    icon: getIcon("fluent:arrow-growth-20-filled"),
  },

  {
    title: "Refil Sale",
    path: "/refilsales",
    icon: getIcon("entypo:shop"),
  },
  {
    title: "Invoice Management",
    path: "/invoices",
    icon: getIcon("fa7-solid:file-invoice-dollar"),
  },
  {
    title: "Cash Memo Punch",
    path: "/cash-memo",
    icon: getIcon("file-icons:docz"),
  },


  {
    title: "Consumer List",
    path: "/trash",
    icon: getIcon("eva:people-fill"),
  }

];

export const superAdminUserNavConfig: INavConfig[] = [
  {
    title: "dashboard",
    path: ROUTES.root,
    icon: getIcon("eva:pie-chart-2-fill"),
  },
  {
    title: "Register Consumer",
    path: "/register",
    icon: getIcon("mdi:register"),
  },
  {
    title: "Find Consumer",
    path: "/find",
    icon: getIcon("eva:search-fill"),
  },

  {
    title: "Date Wise Reports",
    path: "/reports",
    icon: getIcon("ic:baseline-sim-card-download"),
  },
  {
    title: "File upload",
    path: "/uploads",
    icon: getIcon("material-symbols:cloud-upload"),
  },
  {
    title: "Sales & Connection",
    path: "/connections",
    icon: getIcon("fluent:arrow-growth-20-filled"),
  },

  {
    title: "Refil Sale",
    path: "/refilsales",
    icon: getIcon("entypo:shop"),
  },
  {
    title: "Invoice Management",
    path: "/invoices",
    icon: getIcon("fa7-solid:file-invoice-dollar"),
  },
  {
    title: "Cash Memo Punch",
    path: "/cash-memo",
    icon: getIcon("file-icons:docz"),
  },

  {
    title: "Transacton",
    path: "/transaction",
    icon: getIcon("heroicons:currency-rupee-20-solid"),
  },
  {
    title: "Consumer List",
    path: "/trash",
    icon: getIcon("eva:people-fill"),
  },
  {
    title: "Transacton",
    path: "/transaction",
    icon: getIcon("heroicons:currency-rupee-20-solid"),
  },
  {
    title: "User List",
    path: "/users",
    icon: getIcon("fa-solid:user-tie"),
  },
  {
    title: "User Management",
    path: "/user-management",
    icon: getIcon("fa-solid:users"),
  },
  {
    title: "Agents",
    path: "/agents",
    icon: getIcon("fa-solid:users"),
  },
  {
    title: "Agents Management",
    path: "/agent-management",
    icon: getIcon("ix:user-management-settings"),
  },
  {
    title: "Products",
    path: "/products",
    icon: getIcon("ps:sale-tag"),
  },

];

export const userNavConfig: INavConfig[] = [
  {
    title: "Dashboard",
    path: "/agent-dashboard",
    icon: getIcon("eva:search-fill"),
  },
  {
    title: "Find Consumer",
    path: "/find",
    icon: getIcon("eva:search-fill"),
  },

  {
    title: "Sales & Connection",
    path: "/connections",
    icon: getIcon("fluent:arrow-growth-20-filled"),
  },
  {
    title: "View Consumer List",
    path: "/agent-view",
    icon: getIcon("fluent:arrow-growth-20-filled"),
  },





];

